import React, { useRef, useState, useEffect } from 'react';
import { SearchOutlined } from '@ant-design/icons';
import Highlighter from 'react-highlight-words';
import { Button, Input, Space, Table } from 'antd';
import { Link } from "react-router-dom";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import { useSelector } from 'react-redux';
import DialogConfirme from '../dialog-confirm/dialog-confirm';
import DialogSave from '../dialog-save/dialog-save';
import firebase from '../../config/firebase';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { GlobalConfirmModal, GlobalSuccessModal } from '../modalGlobal/modalGlobal';

require('firebase/auth')

const DataOcurrenceTable = () => {

  const db = firebase.firestore();

  const user = useSelector(state => state.user)
  var userLogado = useSelector(state => state.usuarioLogado);

  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const [datas, setData] = useState([]);
  const searchInput = useRef(null);

  const [openConfirmModal, setOpenConfirmModal] = useState(false);
  const [openSuccessModal, setOpenSuccessModal] = useState(false);
  const [ocurrenceToDelete, setOcurrenceToDelete] = useState(null);

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const fetchData = async () => {
    try {
      if (userLogado > 0) {
        let documents = [];

        const snapshot = await db.collection('ocurrence').get();
        const allDocs = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

        if (user.viewALL) {
          documents = allDocs;
        } 
        else {
          if (user?.uidShipperAffiliates && Array.isArray(user.uidShipperAffiliates)) {
            const affiliateUids = Array.isArray(user?.uidShipperAffiliates) ? user.uidShipperAffiliates : [];
            const primaryUid = user?.uidShipper ? [user.uidShipper] : [];
            const uids = Array.from(new Set([...affiliateUids, ...primaryUid]));

            if (uids.length > 1) {
              documents = allDocs.filter(
                (item) => item.uidShipper && uids.uidShipper.includes(item.uidShipper)
              );
            }
            else {
              documents = allDocs.filter(
                (item) => item.uidShipper && item.uidShipper === user?.uidShipper
              );
            }
          }
          else {
            documents = allDocs.filter(
              (item) => item.uidShipper && item.uidShipper === user?.uidShipper
            );
          }
        }

        setData(documents);
      }
    } catch (error) {
      console.error("Erro ao buscar ocorrências:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);
  
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText('');
  };

  const handleDeleteClick = (record) => {
    setOcurrenceToDelete(record);
    setOpenConfirmModal(true);
  };

  const handleConfirmDelete = async () => {
    setOpenConfirmModal(false);
    if (!ocurrenceToDelete?.id) return;

    try {
      await db.collection('ocurrence').doc(ocurrenceToDelete.id).delete();
      setOpenSuccessModal(true);
      fetchData();
    } catch (error) {
      console.error("Erro ao excluir ocorrência:", error);
    }
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: 'block',
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            Search
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{
              width: 90,
            }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({
                closeDropdown: false,
              });
              setSearchText(selectedKeys[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Filter
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            close
          </Button>
        </Space>
      </div>
    ),
    
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? '#1677ff' : undefined,
        }}
      />
    ),

    onFilter: (value, record) =>{ 

      if (dataIndex === 'cpfCnpj') {
        const cleanValue = value.replace(/[^\w]/g, '').trim();
      
        return (
          (record.cpf && record.cpf.toString().replace(/[^\w]/g, '').toLowerCase().includes(cleanValue.toLowerCase())) ||
          (record.cnpj && record.cnpj.toString().replace(/[^\w]/g, '').toLowerCase().includes(cleanValue.toLowerCase()))
        );
      }
      else if(typeof value === 'string'){
        return record[dataIndex]?.toString().toLowerCase().includes(value.toLowerCase())
      }
      else {
        return record[dataIndex] = value
      }

    }, onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },

    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: '#ffc069',
            padding: 0,
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ''}
        />
      ) : (
        text
      ),
  });

  const columns = [
    {
      title: 'Nome',
      dataIndex: 'name',
      key: 'name',
      width: '30%',
      ...getColumnSearchProps('name'),
      sorter: (a, b) => a.name.localeCompare(b.name),
    },
    {
      title: 'Apenas aplicativo',
      dataIndex: 'isApplication',
      key: 'isApplication',
      width: '15%',
      render: (isApplication) => (isApplication ? 'Sim' : 'Não'), // Exibindo texto "Sim" ou "Não"
    },
    {
      title: 'Apenas Cliente',
      dataIndex: 'isClient',
      key: 'isClient',
      width: '15%',
      render: (isClient) => (isClient ? 'Sim' : 'Não'), // Exibindo texto "Sim" ou "Não"
    },
    {
      title: 'Exige foto',
      dataIndex: 'isPhoto',
      key: 'isPhoto',
      width: '15%',
      ...getColumnSearchProps('isPhoto'),
      sorter: (a, b) => a.isPhoto.localeCompare(b.isPhoto),
      render: (isPhoto) => (isPhoto ? 'Sim' : 'Não'), // Exibindo texto "Sim" ou "Não"
    },
    {
      title: 'Exige Comentário',
      dataIndex: 'isComent',
      key: 'isComent',
      width: '30%',
      ...getColumnSearchProps('isComent'),
      sorter: (a, b) => a.isComent.localeCompare(b.isComent),
      render: (isComent) => (isComent ? 'Sim' : 'Não'), // Exibindo texto "Sim" ou "Não"
    },
    {
      title: 'Ações',
      width: '10%',
      // dataIndex: 'data',
      key: 'action',
          render: (_, record) => (
              <Space size="middle">
                {
                  user?.permissoes?.ocurrence?.isEdit ? (
                    <Link to={'/newOcurrence/' + record.id}>
                      <EditOutlinedIcon />
                    </Link>
                  ) 
                  :
                  (
                    <Link to={'/newOcurrence/' + record.id} state={{viewOnly: true}}>
                      <VisibilityIcon />
                    </Link>
                  )
                }
                {
                  user?.permissoes?.ocurrence?.isDelete ? 
                  (
                    <Link to={'#'}>
                      <DeleteOutlinedIcon onClick={(e) => { e.preventDefault(); handleDeleteClick(record); }} color='error'/>
                    </Link>
                  )
                  :
                  (
                    ""
                  )
                }
              </Space>
          ),
    },
  ];

  return(
      <>
        <Table columns={columns} dataSource={datas} />
        <GlobalConfirmModal
          open={openConfirmModal}
          handleClose={() => setOpenConfirmModal(false)}
          handleConfirm={handleConfirmDelete}
          title="Excluir ocorrência?"
          subtitle={ocurrenceToDelete ? `Deseja realmente excluir a ocorrência "${ocurrenceToDelete.name}"?` : "Esta ação não poderá ser desfeita."}
        />
        <GlobalSuccessModal
          open={openSuccessModal}
          handleClose={() => setOpenSuccessModal(false)}
          title="Ocorrência excluída com sucesso!"
        />
      </>
  ) 

};
export default DataOcurrenceTable;